import { useAnnouncementsStore } from 'src/stores/announcements.js'
import { useFollowRequestsStore } from 'src/stores/follow_requests.js'
import { useInstanceStore } from 'src/stores/instance.js'
import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useUsersStore } from 'src/stores/users.js'

// what decides which navigation items show, read from the stores; one
// source for the panel, the pins, the drawer and the timeline menu
export const navFilterContext = () => {
  const capabilities = useInstanceCapabilitiesStore()
  const instance = useInstanceStore()
  return {
    hasChats: capabilities.pleromaChatMessagesAvailable,
    hasAnnouncements: useAnnouncementsStore().supportsAnnouncements,
    hasDirectory: capabilities.directoryAvailable,
    hasFollowRequests: useFollowRequestsStore().hasFollowRequests,
    isFederating: instance.federating,
    isPrivate: instance.privateMode,
    currentUser: useUsersStore().currentUser,
    supportsBubbleTimeline: capabilities.localBubble,
    supportsBookmarkFolders: capabilities.pleromaBookmarkFoldersAvailable,
  }
}

export const filterNavigation = (
  list = [],
  {
    hasChats,
    hasAnnouncements,
    hasDirectory,
    isFederating,
    isPrivate,
    currentUser,
    hasFollowRequests,
    supportsBookmarkFolders,
    supportsBubbleTimeline,
  } = navFilterContext(),
) => {
  return list.filter(({ criteria, anon, anonRoute }) => {
    const set = new Set(criteria || [])
    if (!isFederating && set.has('federating')) return false
    if (!currentUser && isPrivate && set.has('!private')) return false
    if (!currentUser && !(anon || anonRoute)) return false
    if (!hasFollowRequests && set.has('followRequests')) return false
    if (!hasChats && set.has('chats')) return false
    if (!hasAnnouncements && set.has('announcements')) return false
    if (!hasDirectory && set.has('directory')) return false
    if (!supportsBubbleTimeline && set.has('supportsBubbleTimeline'))
      return false
    if (!supportsBookmarkFolders && set.has('supportsBookmarkFolders'))
      return false
    if (supportsBookmarkFolders && set.has('!supportsBookmarkFolders'))
      return false
    return true
  })
}

export const getListEntries = (store) =>
  store.allLists.map((list) => ({
    name: 'list-' + list.id,
    routeObject: { name: 'lists-timeline', params: { id: list.id } },
    labelRaw: list.title,
    iconLetter: list.title[0],
  }))

export const getBookmarkFolderEntries = (store) =>
  store.allFolders
    ? store.allFolders.map((folder) => ({
        name: 'bookmark-folder-' + folder.id,
        routeObject: { name: 'bookmark-folder', params: { id: folder.id } },
        labelRaw: folder.name,
        iconEmoji: folder.emoji,
        iconEmojiUrl: folder.emoji_url,
        iconLetter: folder.name[0],
      }))
    : []

// every bookmark, before the folders
export const getBookmarkEntries = (store) => [
  {
    name: 'bookmarks',
    routeObject: { name: 'bookmarks' },
    label: 'nav.all_bookmarks',
    icon: 'bookmark',
  },
  ...getBookmarkFolderEntries(store),
]

// a followed hashtag: its timeline
export const getFollowedTagEntries = (tags) =>
  tags.map((tag) => ({
    name: `tag-${tag.name}`,
    routeObject: { name: 'tag-timeline', params: { id: tag.name } },
    labelRaw: `#${tag.name}`,
    iconLetter: '#',
  }))
